import { ResponsiveContext } from '@/components/Responsive/ResponsiveProvider';
import { EPlatform } from '@/utils/enums/platform-enum';
import { Box } from '@mui/material';
import React, { useContext } from 'react';

interface ParamItemProps {
  label?: string;
  value?: React.ReactNode;
  infoPopover?: React.ReactNode;
}

export const ParamItem: React.FC<ParamItemProps> = ({ label, value, infoPopover }) => {
  const { deviceType } = useContext(ResponsiveContext);
  return (
    <Box
      className={`flex items-start flex-wrap text-[14px] ${
        deviceType === EPlatform.WEB ? '' : 'flex-col gap-[6px]'
      }`}
    >
      <label
        className={`w-[150px] ${deviceType === EPlatform.WEB ? 'inline-block mr-8' : 'text-12'}`}
      >
        {label}:
      </label>
      <Box className="flex items-center">
        <span className={`font-bb ${deviceType === EPlatform.WEB ? 'mr-8' : 'mr-4'}`}>{value}</span>
        {infoPopover}
      </Box>
    </Box>
  );
};
